import { render, staticRenderFns } from "./ResetUserPasswordEmailDialog.vue?vue&type=template&id=ba472826&scoped=true"
import script from "./ResetUserPasswordEmailDialog.vue?vue&type=script&lang=js"
export * from "./ResetUserPasswordEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./ResetUserPasswordEmailDialog.vue?vue&type=style&index=0&id=ba472826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba472826",
  null
  
)

export default component.exports